export default "https://cdn.questicon.mathletics.com/assets/images/Problem-Solving_R-024ee0b33dd74bee40f854fbb1a98044.png";